export class PerfectShotImageManagerPane extends HTMLElement 
{
    constructor()
    {
        super();
    }

    connectedCallback()
    {
        this.init();
    }

    init()
    {
        this.initEventListener();
    }

    initEventListener()
    {
        this.addEventListener('click', (event) => {
            if (event.target.classList.contains('perfect-shot-image-manager__delete-button')) {
                const imageId = event.target.dataset.imageId;
                this.deleteImage(imageId);
            }
        });
    }

}

customElements.define('perfect-shot-image-manager-pane', PerfectShotImageManagerPane);